/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/recurring_run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Required input.
 * User setting to enable or disable the recurring run.
 * Only used for creation of recurring runs. Later updates use enable/disable API.
 *
 *  - DISABLE: The recurring run won't schedule any run if disabled.
 * @export
 */
export const RecurringRunMode = {
  MODE_UNSPECIFIED: 'MODE_UNSPECIFIED',
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE',
} as const;
export type RecurringRunMode = (typeof RecurringRunMode)[keyof typeof RecurringRunMode];

export function instanceOfRecurringRunMode(value: any): boolean {
  for (const key in RecurringRunMode) {
    if (Object.prototype.hasOwnProperty.call(RecurringRunMode, key)) {
      if (RecurringRunMode[key as keyof typeof RecurringRunMode] === value) {
        return true;
      }
    }
  }
  return false;
}

export function RecurringRunModeFromJSON(json: any): RecurringRunMode {
  return RecurringRunModeFromJSONTyped(json, false);
}

export function RecurringRunModeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RecurringRunMode {
  return json as RecurringRunMode;
}

export function RecurringRunModeToJSON(value?: RecurringRunMode | null): any {
  return value as any;
}

export function RecurringRunModeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): RecurringRunMode {
  return value as RecurringRunMode;
}
